<template>
  <b-alert
    show
    variant="info"
    class="mt-3 text-center"
  >
    {{ $t('pages.new_booking.redirect_return_without_cart') }}
  </b-alert>
</template>

<script>
  export default {
    name: 'RedirectReturnNotice',
  }
</script>

<style scoped>

</style>
